const getFilterStatus = state => state?.orderManagementFilters?.filterStatus
const getFilterDate = state => state?.orderManagementFilters?.filterDate
const getFilterBranch = state => state?.orderManagementFilters?.filterBranch
const getOrderSearchValue = state =>
  state?.orderManagementFilters?.orderSearchValue

export { getFilterStatus, getFilterDate, getFilterBranch, getOrderSearchValue }
